module.exports = __webpack_public_path__ + "img/honor-1.f25efd2b.png";